import { Crown, ArrowRight } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { usePlan } from '../contexts/PlanContext';

export const UpgradeBanner = ({ feature, message }) => {
  const { handleUpgrade } = usePlan();
  return (
    <div className="bg-gradient-to-r from-[#003166] to-[#0077FF] rounded-xl p-6 text-white flex flex-col sm:flex-row items-center gap-4" data-testid="upgrade-banner">
      <div className="w-12 h-12 rounded-xl bg-[#FF9900]/20 flex items-center justify-center flex-shrink-0">
        <Crown size={24} weight="fill" className="text-[#FF9900]" />
      </div>
      <div className="flex-1 text-center sm:text-left">
        <h3 className="font-bold text-lg">Upgrade to Professional</h3>
        <p className="text-white/70 text-sm mt-0.5">
          {message || `The "${feature}" feature is available on the Professional plan and above.`}
        </p>
      </div>
      <Button
        onClick={handleUpgrade}
        className="bg-[#FF9900] hover:bg-[#FF9900]/90 text-white rounded-lg px-5"
        data-testid="upgrade-banner-btn"
      >
        Upgrade Now <ArrowRight size={16} className="ml-1" />
      </Button>
    </div>
  );
};

export const ClientLimitBanner = ({ current, max }) => {
  const { handleUpgrade } = usePlan();
  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center gap-3" data-testid="client-limit-banner">
      <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center flex-shrink-0">
        <Crown size={20} weight="fill" className="text-red-500" />
      </div>
      <div className="flex-1">
        <p className="text-red-800 font-semibold text-sm">Client Limit Reached ({current}/{max})</p>
        <p className="text-red-600 text-xs">Upgrade your plan to add more clients.</p>
      </div>
      <Button
        onClick={handleUpgrade}
        variant="outline"
        className="border-red-300 text-red-700 hover:bg-red-50 text-xs rounded-lg"
        data-testid="client-limit-upgrade-btn"
      >
        Upgrade
      </Button>
    </div>
  );
};
